import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../sections/Navbar";
import ContactSection from "../sections/ContactSection";
import styles from "./ProjectsPage.module.css";

const projectData = {
  Residential: [
    {
      title: "Contemporary Living Spaces",
      description: "A harmonious blend of modern aesthetics and comfortable living. Handpicked textures and curated furniture pieces.",
      featuredImage: "/media/r1 copy.jpg",
      gallery: ["/media/r2 copy.jpg", "/media/r3 copy.jpg", "/media/r4 copy.jpg"]
    },
    {
      title: "Minimalist Bedrooms",
      description: "Clean lines, neutral tones, and serene environments designed for perfect rest and relaxation.",
      featuredImage: "/media/1 copy.jpg",
      gallery: ["/media/2 copy.jpg", "/media/3 copy.jpg", "/media/4 copy.jpg", "/media/22.jpg"]
    },
    {
      title: "Luxury Dining & Kitchen",
      description: "Elegant open-plan designs that elevate everyday dining experiences with premium finishes.",
      featuredImage: "/media/5 copy.jpg",
      gallery: ["/media/6 copy.jpg", "/media/7 copy.jpg"]
    },
    {
      title: "Executive Residential Suites",
      description: "Bespoke lighting and custom wardrobes tailored for a sophisticated, executive lifestyle.",
      featuredImage: "/media/b1 copy.jpg",
      gallery: ["/media/b2 copy.jpg", "/media/h1 copy.jpg", "/media/h2 copy.jpg", "/media/h3 copy.jpg", "/media/h4 copy.jpg"]
    },
    {
      title: "Signature Interiors",
      description: "Statement interiors crafted with meticulous attention to detail — where every corner tells a story.",
      featuredImage: "/media/h1 (10).jpg",
      gallery: ["/media/h1 (11).jpg", "/media/h1 (12).jpg"]
    }
  ],
  Commercial: [
    {
      title: "Modern Corporate Office",
      description: "Fostering collaboration with open layouts, ergonomic furniture, and inspiring breakout zones.",
      featuredImage: "/commercial/PHOTO-2026-07-08-13-58-29.jpg",
      gallery: [
        "/commercial/PHOTO-2026-07-08-13-58-29_1.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_2.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_3.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_4.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_5.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_6.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_7.jpg"
      ]
    },
    {
      title: "Retail & Boutique Spaces",
      description: "Engaging storefronts and interior layouts strategically designed to attract and retain customers.",
      featuredImage: "/commercial/PHOTO-2026-07-08-13-58-29_8.jpg",
      gallery: [
        "/commercial/PHOTO-2026-07-08-13-58-29_9.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_10.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_11.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_12.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_13.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_14.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_15.jpg"
      ]
    },
    {
      title: "Hospitality & Lounge",
      description: "Warm, welcoming, and beautifully lit atmospheres crafted specifically for guest comfort.",
      featuredImage: "/commercial/PHOTO-2026-07-08-13-58-29_16.jpg",
      gallery: [
        "/commercial/PHOTO-2026-07-08-13-58-29_17.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_18.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_19.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_20.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_21.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_22.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_23.jpg"
      ]
    },
    {
      title: "Premium Commercial Interiors",
      description: "Sophisticated commercial environments designed to impress clients and energize teams.",
      featuredImage: "/commercial/PHOTO-2026-07-08-13-58-29_24.jpg",
      gallery: [
        "/commercial/PHOTO-2026-07-08-13-58-29_25.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_26.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_27.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_28.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_29.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_30.jpg",
        "/commercial/PHOTO-2026-07-08-13-58-29_31.jpg"
      ]
    }
  ],
  Renovations: [
    {
      title: "Urban Loft Renovation",
      description: "Transforming old spaces into modern, functional environments while retaining industrial charm.",
      featuredImage: "/media/l1 copy.jpg",
      gallery: ["/media/l2 copy.jpg", "/media/l3 copy.jpg", "/media/l4 copy.jpg", "/media/l44 copy.jpg"]
    },
    {
      title: "Heritage Restoration",
      description: "Preserving classic architecture while updating interior amenities to modern standards.",
      featuredImage: "/media/l5 copy.jpg",
      gallery: ["/media/l6 copy.jpg", "/media/l7 copy.jpg", "/media/l8 copy.jpg", "/media/l9 copy.jpg"]
    }
  ]
};

const ProjectsPage = () => {
  const location = useLocation();
  const [activeCategory, setActiveCategory] = useState("Residential");
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentGallery, setCurrentGallery] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    const searchParams = new URLSearchParams(location.search);
    const category = searchParams.get("category");
    if (category && projectData[category]) {
      setActiveCategory(category);
    }
  }, [location]);

  const projects = projectData[activeCategory] || [];

  const openLightbox = (gallery) => {
    setCurrentGallery(gallery);
    setCurrentImageIndex(0);
    setLightboxOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = "auto";
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev + 1) % currentGallery.length);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev - 1 + currentGallery.length) % currentGallery.length);
  };

  return (
    <div className={styles.pageWrapper}>
      <Navbar />
      
      <div className={styles.videoHeroSection}>
        <video 
          autoPlay 
          muted 
          loop 
          playsInline 
          className={styles.heroVideoBackground}
        >
          <source src="/create_a_banner_vedio.mp4" type="video/mp4" />
        </video>
        <div className={styles.videoOverlay}></div>
        <div className={styles.videoHeroContent}>
          <h1 className={styles.pageTitle}>Our Projects</h1>
          <p className={styles.pageSubtitle}>Experience luxury and precision in every detail.</p>
        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.tabs}>
          {Object.keys(projectData).map((cat) => (
            <button
              key={cat}
              className={`${styles.tabButton} ${activeCategory === cat ? styles.active : ""}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className={styles.parallaxProjectList}>
          {projects.map((proj, index) => {
            const fullGallery = [proj.featuredImage, ...proj.gallery];
            return (
              <div 
                key={index} 
                className={styles.parallaxSection}
                style={{ backgroundImage: `url('${proj.featuredImage}')` }}
              >
                <div className={styles.glassCard}>
                  <h2 className={styles.projectTitle}>{proj.title}</h2>
                  <p className={styles.projectDescription}>{proj.description}</p>
                  <button 
                    className={styles.viewDetailsBtn}
                    onClick={() => openLightbox(fullGallery)}
                  >
                    View Project Gallery
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <ContactSection />

      {lightboxOpen && (
        <div className={styles.lightboxOverlay} onClick={closeLightbox}>
          <button className={styles.closeBtn} onClick={closeLightbox}>×</button>
          <button className={styles.navBtnLeft} onClick={prevImage}>&#10094;</button>
          
          <div className={styles.lightboxImageContainer} onClick={(e) => e.stopPropagation()}>
            <img 
              src={currentGallery[currentImageIndex]} 
              alt="Gallery Preview" 
              className={styles.lightboxImage} 
            />
          </div>
          
          <button className={styles.navBtnRight} onClick={nextImage}>&#10095;</button>
        </div>
      )}
    </div>
  );
};

export default ProjectsPage;
